<template>
  <!-- 非普本专业列表 用于关联使用 -->
  <div class="table_dialog">
    <el-table
      class="table"
      v-loading="loading"
      ref="multipleTableRef"
      :data="tableData"
      height="450px"
      border
      :header-cell-style="{ background: '#f5f7fa' }"
      style="width: 100%; margin-top: 10px"
      :header-cell-class-name="cellClass"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column
        prop="majorName"
        label="专业名称"
        min-width="300"
        align="center"
        :show-overflow-tooltip="true"
        inputSearch="true"
      >
        <template #header>
          <!-- <el-popover placement="bottom" :width="300" trigger="click">
            <template #reference>
              <div>
                <span class="search-title">专业名称</span>
                <el-icon><Search /></el-icon>
              </div>
            </template>
           
          </el-popover> -->
          <el-input
              v-model="majorName"
              class="m-2"
              placeholder="专业名称"
              size="large"
              clearable
              @clear="searchData"
            >
              <template #suffix>
                <el-icon @click="searchData" clearable><Search /></el-icon>
              </template>
            </el-input>
        </template>
        <template #default="scope">
          <span :class="scope.row.majorName ? '' : 'gray'">{{
            scope.row.majorName ? scope.row.majorName : "未设置"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="majorCategoryName"
        label="学习层次"
        width="160"
        align="center"
        :show-overflow-tooltip="true"
      >
       <template #default="scope">
            <span :class="scope.row.majorCategoryName ? '' : 'gray'">{{
              scope.row.majorCategoryName ? scope.row.majorCategoryName : "未设置"
            }}</span>
          </template>
      </el-table-column>
      <el-table-column
        prop="categoryName"
        label="专业类别名称"
        width="300"
        align="center"
        :show-overflow-tooltip="true"
      >
       <template #default="scope">
            <span :class="scope.row.categoryName ? '' : 'gray'">{{
              scope.row.categoryName ? scope.row.categoryName : "未设置"
            }}</span>
          </template>
      </el-table-column>
    </el-table>
    <div class="choose_bom">
    <span style="margin-right: 10px" v-if="multipleSelection.length > 0"
      >已选择【
      <b class="select_red" style="font-size: 16px">{{
        multipleSelection.length
      }}</b>
     】个专业</span
    >
    <span style="margin-right: 10px" v-else>请选择关联专业</span>
    <div style="font-size: 16px; float: right">
      <el-button @click="closeDialog($event)" size="large">取消</el-button>
      <el-button v-if="!submitDisabled" type="primary" size="large" @click="clickTrue($event)"
        :disabled = "submitDisabled">确定</el-button
      >
      <el-button type="primary" loading v-else size="large" 
        >提交中</el-button
      >
    </div>
  </div>
  </div>
</template>

<script>
import {
  getMajorList,
  addSchoolMajor,
  updateSchoolMajor,
} from "network/majorSchoolAllocation.js";
import { reactive, onMounted, watch, toRefs, ref, toRaw, nextTick } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { isNull, lostFocus } from "common/utils.js";
export default {
  name: "NotPbMajorRelevancy",
  props: { idsArray: Array, schoolId: Number, categoryId: Number },
  components: {},
  emits: { "update-list": null, "close-dialog": null },
  setup(props, { emit }) {
    //这里定义一个结构体，用来保存项目信息
    const data = reactive({
      tableData: [],
      // 表格是否在加载中
      loading: true,
      majorName: "",
      multipleSelection: [], //选中行数据
      selectIds: [],
      nowSchoolId: null,
      submitDisabled: false,
      category: null
    });
    const multipleTableRef = ref(null);
    //挂载后调用函数获取项目数据
    onMounted(() => {
      data.selectIds = JSON.parse(JSON.stringify(props.idsArray));
      data.nowSchoolId = JSON.parse(JSON.stringify(props.schoolId));
      data.category = JSON.parse(JSON.stringify(props.categoryId));
      getMajorData(""); //请求专业列表数据
    });
    // 去掉全选按钮操作
    const cellClass = (row) => {
      if (row.columnIndex === 0) {
        return "disabledCheck";
      }
    };
    //初始化选中的行
    function changeSelRow(ids) {
      if (ids) {
        //1 先全部取消
        data.tableData.forEach((item) => {
          multipleTableRef.value.toggleRowSelection(item, false);
        });
      }
      // 赋值选中行数据
      data.multipleSelection = ids;
      // 2.再重新选中父组件传过来存在的数据
      data.tableData.forEach((item) => {
        ids.forEach((subItem) => {
          if (item.majorId === subItem) {
            multipleTableRef.value.toggleRowSelection(item, true);
          }
        });
      });
    }

    //获取列表
    const getMajorData = () => {
      const obj = {
        majorName: data.majorName,
        majorIds: data.selectIds,
        category: data.category
      };
      getMajorList(obj)
        .then((result) => {
          /*Data.projectDetailData这个变量是我们定义的reactive对象
          所以你打印出来他是一个数据代理的实例，并非array(),所以想要把
          获取的报文数据复制到里面，需要使用深拷贝*/
          if (result && result.code == 1) {
            data.tableData = result.result;
            data.loading = false;
            nextTick(() => {
              changeSelRow(data.selectIds);
            });
          } else {
            data.loading = false;
            ElMessage.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    // 表格多选行处理
    const handleSelectionChange = (row) => {
      data.multipleSelection = JSON.parse(JSON.stringify(row));
    };
    // 取消
    const closeDialog = (e) => {
      // lostFocus(e);
      // if (data.multipleSelection && data.multipleSelection.length > 0) {
      //   ElMessageBox.confirm("是否关闭弹窗", "取消", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning",
      //   })
      //     .then(() => {
      //       data.multipleSelection = [];
      //       data.tableData.forEach((item) => {
      //         multipleTableRef.value.toggleRowSelection(item, false);
      //       });
      //       emit("close-dialog");
      //     })
      //     .catch(() => {});
      // } else {
        emit("close-dialog");
      // }
    };
    //确定选中
    const clickTrue = (e) => {
      lostFocus(e);
      if (data.multipleSelection.length == 0) {
        ElMessage.warning("请先选择关联专业");
      } else {
        data.submitDisabled = true;
        if (data.selectIds.length > 0) {
          // 存在已关联专业  走编辑接口
          var ids = [];
          toRaw(data.multipleSelection).map((org) => {
            ids.push(org.majorId);
          });
          updateSchoolMajor(data.nowSchoolId, ids).then((res) => {
            if (res && res.code == 1) {
              data.submitDisabled = false;
              ElMessageBox.alert(res.message);
              emit("close-dialog");
              emit("update-list");
            } else {
               data.submitDisabled = false;
              ElMessage.error(res.message);
            }
          });
        } else {
          // 还未关联 走添加接口
          var ids = [];
          toRaw(data.multipleSelection).map((org) => {
            ids.push(org.majorId);
          });
          addSchoolMajor(data.nowSchoolId, ids).then((res) => {
            if (res && res.code == 1) {
               data.submitDisabled = false;
              ElMessageBox.alert(res.message);
              emit("close-dialog");
              emit("update-list");
            } else {
               data.submitDisabled = false;
              ElMessage.error(res.message);
            }
          });
        }
      }
    };
    //搜索
    const searchData = () => {
      var ids = [];
      toRaw(data.multipleSelection).map((org) => {
        ids.push(org.majorId);
      });
      data.selectIds = ids;
      getMajorData();
    };
    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      cellClass,
      multipleTableRef,
      getMajorData,
      handleSelectionChange,
      closeDialog,
      clickTrue,
      isNull,
      searchData,
    };
  },
};
</script>
<style scoped>
.choose_bom {
  margin-top: 30px;
  line-height: 35px;
}
.select_red {
  color: red;
}
::v-deep .el-form-item--large .el-form-item__content {
  line-height: 23px !important;
}
/* 深度选择器 去掉全选按钮 */
::v-deep .el-table .disabledCheck .cell .el-checkbox__inner {
  display: none;
}

::v-deep .el-table .disabledCheck .cell::before {
  content: "";
  text-align: center;
}
</style>

